import { GetProjectsResponse } from "api/generatedApi";
import { createContext, useContext } from "react";

interface Type {
  projects: GetProjectsResponse | undefined;
}

export const ProjectsListContext = createContext<Type | null>(null);

export const useProjects = () => {
  const context = useContext(ProjectsListContext);
  if (!context) {
    throw new Error("useProjects must be used within a ProjectsProvider");
  }
  return context;
};
